import { ApiServerHelpUsage } from 'js/components/pipelines/cards/apiServer/Request/ApiServerHelpUsage';
import { FlowNodes } from 'js/components/pipelines/FlowNodes';
import { getResourceEntity } from 'js/lib/PipelineUtils';
import { mapValues, pick } from 'lodash';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import React, { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';

const ApiServerFlowNodes = ({
  rootNodeId,
  children = null,
  toolbarItems = undefined,
  nodeProps = {},
  layoutDirection = undefined,
}: {
  rootNodeId: string;
  children?: ReactNode;
  toolbarItems?: any[];
  nodeProps?: any;
  layoutDirection?: 'LR' | 'TB';
}) => {
  const entities = useSelector((state: any) => state.entities);
  const { flowNodes } = entities;
  const branches = useSelector((state: any) => state.pipelines.branches);

  const pipelineItems = useMemo(() => {
    const branch =
      !isNil(rootNodeId) && has(branches, rootNodeId)
        ? branches[rootNodeId]
        : { items: [], edges: [] };

    const pipelineItems = mapValues(pick(flowNodes, branch.items), (flowNode) =>
      getResourceEntity(flowNode, entities),
    );

    const rootFlowNode = flowNodes[rootNodeId];
    const rootDataSource = rootFlowNode?.data_source_id
      ? entities.sources[rootFlowNode.data_source_id]
      : null;
    const endpointMappings = rootDataSource?.endpoint_mappings || [];
    const mappingsByDataSetId = endpointMappings.reduce((acc, mapping) => {
      acc[mapping.data_set_id] = mapping;
      return acc;
    }, {});

    Object.keys(pipelineItems).forEach((key) => {
      const item = pipelineItems[key];
      // If this is an api_request node (dataset), merge the endpoint mapping info
      if (item.node_type === 'api_request' && item.id && mappingsByDataSetId[item.id]) {
        const mapping = mappingsByDataSetId[item.id];
        pipelineItems[key] = {
          ...item,
          endpoint_spec: {
            ...item.endpoint_spec,
            route: mapping.route,
            method: mapping.method,
          },
        };
      }
    });

    return pipelineItems;
  }, [rootNodeId, branches, flowNodes, entities]);

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <FlowNodes
        id={rootNodeId}
        hideMiniMap
        keepFlowsOrder
        toolbarItems={toolbarItems}
        pipelineItems={pipelineItems}
        isApiServerFlow
        nodeProps={nodeProps}
        layoutDirection={layoutDirection}
      >
        <ApiServerHelpUsage />
        {children}
      </FlowNodes>
    </div>
  );
};

export default ApiServerFlowNodes;
